import { render, staticRenderFns } from "./datosContratante.vue?vue&type=template&id=01cac99a"
import script from "./datosContratante.vue?vue&type=script&lang=js"
export * from "./datosContratante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports